import { render, staticRenderFns } from "./listImg.vue?vue&type=template&id=36f3cb8e&scoped=true"
import script from "./listImg.vue?vue&type=script&lang=js"
export * from "./listImg.vue?vue&type=script&lang=js"
import style0 from "./listImg.vue?vue&type=style&index=0&id=36f3cb8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f3cb8e",
  null
  
)

export default component.exports